module.exports = __webpack_public_path__ + "templates/booking.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/booking/templates/booking.html
// module id = WmzD
// module chunks = 1